module Elma.Bindings {
    export interface IToggleReadMoreParams {
        cssClassName: string;
        beforeText: string;
        closedText: string;
    }
    export class ToggleReadMore  {

        public init(element: HTMLElement, valueAccessor: () => IToggleReadMoreParams, allBindingsAccessor?: KnockoutAllBindingsAccessor, bindingContext?: KnockoutBindingContext) {
            // This will be called when the binding is first applied to an element
            // Set up any initial state, event handlers, etc. here
            if (!bindingContext)
                return;
            let viewModel = bindingContext.$data || bindingContext.$rawData,
                valueUnwrapped = ko.unwrap(valueAccessor()),
                $el = $(element);

            let cssClass: string = valueUnwrapped.cssClassName;
            let beforeTextValue = valueUnwrapped.beforeText;
            let closedTextValue = valueUnwrapped.closedText;
            let prevElement = $el.prev();
            

            ko.utils.registerEventHandler(element, "click", function () {               
                prevElement.toggleClass(cssClass);
                if (prevElement.hasClass(cssClass)) {
                    $(element).find(".js-text").text(closedTextValue);
                }
                else {
                    $(element).find(".js-text").text(beforeTextValue);
                }
            });
        }

        public update(element: HTMLElement, valueAccessor: () => IToggleReadMoreParams, allBindingsAccessor?: KnockoutAllBindingsAccessor, bindingContext?: KnockoutBindingContext) {
            if (!bindingContext)
                return;

            let value = valueAccessor();
        }
    };
    ko.bindingHandlers['toggleReadMore'] = new ToggleReadMore();
}
